import { ApiClient } from "@shared/index"
import { PUP_ID } from "../config"

const pupAPiUrl = import.meta.env.VITE_API_URL

if (!pupAPiUrl) {
  throw new Error("VITE_API_URL is required")
}

export const apiClient = new ApiClient(pupAPiUrl, PUP_ID)